import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import FormField from '@cloudscape-design/components/form-field'
import { startsWith } from 'lodash'

export type LabeledInputProps = {
    label: string,
    value: string, 
    onChange?: (s: string) => void, 
    validate?: (value: string, label: string) => boolean,
    readOnly?: boolean, 
    [rest: string]: any,
}

export default ({ label, value, onChange, validate, readOnly = false, ...rest }: LabeledInputProps) => {

    const valid = (!readOnly && validate) ? validate(value, label) : true

    function handleChange(s: string) {
        if (!onChange) return

        // let formatted = s.slice(0,3)
        // if (s.length > 3) formatted += '-' + s.slice(3,6)
        // if (s.length > 6) formatted += '-' + s.slice(6,10)
        // onChange(formatted)
        onChange(s)
    }

    return (
        <FormField label={label} info={label ? validate || readOnly ? '' : 'Optional' : ''} >
            <PhoneInput
                country={'us'} onlyCountries={['us']} disableCountryCode={true} masks={{us: '...-...-....'}}
                placeholder="206-555-1234"
                value={value}
                onChange={ (phone: string) => handleChange(phone) }
                isValid={(inputNumber, country, countries) => !startsWith(inputNumber, '1') && inputNumber.length === 10 }
                {...rest}
            />
        </FormField> 
    )
}